export default __webpack_public_path__ + "static/media/direction.6024de6b.svg";